module.exports = {
      id: "comm-cinema-usage",
      viewBox: "0 0 415.94 49.818",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-cinema",
      toString: function () {
        return this.url;
      }
    }